import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

import { Subject } from 'rxjs';

import { Store } from '@ngrx/store';
import { FAMILIES, Product, TYPES } from '../../../../../../commons/models/product';
import * as ProductsActions from '../../../../../../store/actions/products.actions';
import { AppState } from '../../../../../../store/reducers';
import { DialogComponent } from '../../../../../shared/components/dialog/dialog.component';

@Component({
  selector: 'app-new-product',
  templateUrl: './new-product.component.html',
  styleUrls: ['./new-product.component.scss']
})
export class NewProductComponent implements OnInit {
  private unsubscribe$ = new Subject<void>();
  productForm: UntypedFormGroup;

  private _product: Product;
  productImage: string | ArrayBuffer | null = null;
  selectedFile: File | null = null;


  types = TYPES;
  families = FAMILIES;

  constructor(
    private fb: UntypedFormBuilder,
    public store$: Store<AppState>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.createForm();
    if (this.data) {
      this.product = this.data.product;
    }

    this._initFormValues(this._product);
    this.ngOnChanges();
  }

  createForm() {
    const productGroup = {
      name: ["", Validators.required],
      price: ["", Validators.required],
      type: ["", Validators.required],
      description: ["", Validators.required],
      editable: [""],
      family: ["", Validators.required],      
      photo: [null]
    };

    this.productForm = this.fb.group(productGroup);
  }

  private ngOnChanges() {
    if (this.productForm) {
      this.productForm.reset();
      this.productForm.markAllAsTouched();
      this._initFormValues(this._product);
    }
  }


  private _initFormValues(product?: Product) {
    if (product) {
      //console.log('Product:', product);
      this.productForm.patchValue({
        name: product.name,
        price: product.price,
        type: product.type,
        description: product.description,
        editable: product.editable,
        family: product.family,
      });
      this.setImagePreview(this.product.photoUrl);
    } else {
      this.productForm.patchValue({ family: FAMILIES[0] });
      this.productForm.get('photo').setValidators(Validators.required);
      this.productForm.markAllAsTouched();
    }
  }

  previewImage(file: File): void {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      const previewElement = document.getElementById('imagePreview') as HTMLDivElement;
      previewElement.style.backgroundImage = `url(${e.target.result})`;
    };
    reader.readAsDataURL(file);
    this.productForm.patchValue({
      photo: file
    })
    this.productForm.markAsDirty();
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];
    this.selectedFile = file;
    this.productForm.patchValue({
      photo: file
    })
    this.productForm.markAsDirty();
    this.previewImage(file);
  }


  setImagePreview(imageUrl: string): void {
    const previewElement = document.getElementById('imagePreview') as HTMLDivElement;

    if (imageUrl) {
      previewElement.style.backgroundImage = `url(${imageUrl})`;
      //console.log(`url(${imageUrl})`);
    } else {
      previewElement.style.backgroundImage = `url(../../../../../../../assets/images/no-image.jpg)`;
    }
  }


  cancel() {
    // Verifica se il form ha modifiche
    if (this.productForm.dirty) {
      // Se ci sono modifiche, mostra il dialog di conferma
      this.store$.dispatch(ProductsActions.requestCloseProductsDialog());
    } else {
      // Se il form è pristine (nessuna modifica), chiudi
      this.store$.dispatch(ProductsActions.closeProductsDialog());
    }
  }

  private _prepareSaveProduct(): Product {
    let savingProduct: Product = Product.fromFormGroup(this.productForm, this.product);
    return savingProduct;
  }

  save() {
    if (!this.product && !this.selectedFile) {
      let dialogRef = this.dialog.open(DialogComponent, {
        disableClose: false,
      });

      dialogRef.componentInstance.title = "Errore";
      dialogRef.componentInstance.confirmMessage = "L'immagine è obbligatoria per la creazione del prodotto.";

      return;
    }
    let unsavedEntity = this._prepareSaveProduct();
    this.store$.dispatch(ProductsActions.saveProduct({ product: unsavedEntity }));
  }


  resetForm() {
    this.productForm.reset();
    this.productImage = null;
    this.selectedFile = null;
  }

  get product(): Product {
    return this._product;
  }

  set product(product: Product) {
    this._product = product;
    this.ngOnChanges();
  }

}
